import React, { useContext, useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import AuthContext from "../../Context/AuthContext";
import Spinner from "react-bootstrap/Spinner";
import axios from "axios";
import StripeSummary from "../Components/StripeSummary";
import MorosityPercentage from "../Components/MorosityPercentage";
import CashDeposits from "../Components/CashDeposits";
import { FaHouseUser, FaUsers } from "react-icons/fa";
function Dashboard() {
  const [users, setUsers] = useState(0);
  const [residences, setResidences] = useState(0);
  const [account, setAccount] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [financialInfo, setFinancialInfo] = useState();
  const [morosityPercentage, setMorosityPercentage] = useState(0);
  const [cashDeposits, setCashDeposits] = useState(0);

  const { state, signout } = useContext(AuthContext);

  useEffect(() => {
    async function fetch() {
      try {
        const result = await axios({
          method: "get",
          url: `${process.env.REACT_APP_BACKEND_URL}/accounts/dashboard/${state.account}`,
          headers: {
            Authorization: `Bearer ${state.token}`,
          },
        });
        setAccount(result.data.account);
        setUsers(result.data.users);
        setResidences(result.data.residences);

        const response = await axios({
          method: "post",
          url: `${process.env.REACT_APP_BACKEND_URL}/accounts/financial/info/${state.account}`,
          data: {
            userTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          },
          headers: {
            Authorization: `Bearer ${state.token}`,
          },
        });

        setFinancialInfo(response.data.financialInfo);
        setMorosityPercentage(response.data.morosityPercentage);
        setCashDeposits(response.data.cashDeposits ?? 0);
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        if (error.response.status === 401) {
          signout();
        }
      }
    }
    fetch();
  }, [state.token, state.account, signout]);

  if (isLoading) {
    return (
      <>
        <Spinner animation="border" />
        <h3>Obteniendo información...</h3>
      </>
    );
  } else {
    if (state.role === "admin" || state.role === "root") {
      return (
        <Col className="dashboard">
          <Col className="center mb-4">
            <h1>{account.name}</h1>
          </Col>
          <Row className="justify-content-center align-items-center mb-4">
            <Col lg={4}>
              <Col className="dashboard-residents">
                <Row className="align-items-center">
                  <Col lg={2}>
                    <FaUsers />
                  </Col>
                  <Col lg={8}>
                    <h5>Residentes</h5>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <h4 className="counter">{users}</h4>
                  </Col>
                </Row>
              </Col>
            </Col>
            <Col lg={4}>
              <Col className="dashboard-residents">
                <Row className="align-items-center">
                  <Col lg={2}>
                    <FaHouseUser />
                  </Col>
                  <Col lg={8}>
                    <h5>Residencias</h5>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <h4 className="counter">{residences}</h4>
                  </Col>
                </Row>
              </Col>
            </Col>
            <Col lg={4}>
              <Col className="dashboard-residents">
                <CashDeposits cashDeposits={cashDeposits} />
              </Col>
            </Col>
          </Row>
          <Row className="align-items-center justify-content-center">
            <Col lg={8}>
              <StripeSummary financialInfo={financialInfo} />
            </Col>
            <Col lg={4}>
              <MorosityPercentage morosityPercentage={morosityPercentage} />
            </Col>
          </Row>
        </Col>
      );
    } else {
      return (
        <Col className="center sublime-text">
          <h2>Esta sección es exclusiva para administradores de comité</h2>
        </Col>
      );
    }
  }
}

export default Dashboard;
